/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { InputSelect, Label, Button, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewPartCommandsHasVariables = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    document.title = "Edição de ligação de part Command - variável";
    const [loading, setLoading] = useState(true);
    const [parts, setParts] = useState([]);
    const [variables, setVariables] = useState([]);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());

    const partCommandField = useRef();
    const variableFiled = useRef();

    const partCommandValue = useRef();
    const variableValue = useRef();

    
    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getPartCommand(){
            setLoading(true)
            let currentItem = await Services.current.getPartCommandHasVariable(id);
            if(currentItem){
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getParts(){
            let currentItem = await Services.current.getAllPartCommands();
            setParts(currentItem);
        }

        async function getVariables(){
            let currentItem = await Services.current.getPartCommandsVariables();
            setVariables(currentItem);
        }

        getPartCommand();
        getVariables();
        getParts();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(partCommandValue.current)){
            let form = new FormData();
            if(partCommandValue.current){form.append('part_command', partCommandValue.current)}
            if(variableValue.current){form.append('variable', variableValue.current)}

            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editPartCommandHasVariable(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>Conexão de part Command - variável</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={"part Command"} aling="flex-start"/>
                            <InputSelect
                                key={'part_command'}
                                name={'part_command'}
                                id={'part_command'}
                                placeholder={"Part Command"}
                                invalidMessage = {"Part Command inválido!"}
                                options={parts}
                                innerRef={partCommandField}
                                value={partCommand?.part_command}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => partCommandValue.current = value}>
                            </InputSelect>                      
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={"variável"} aling="flex-start"/>
                            <InputSelect
                                key={'variable'}
                                name={'variable'}
                                id={'variable'}
                                placeholder={"Variável"}
                                invalidMessage = {"Variável inválida!"}
                                options={variables}
                                innerRef={variableFiled}
                                value={partCommand?.variable}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => variableValue.current = value}>
                            </InputSelect>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deletePartCommandHasVariable(id);
                            navigate('/PartCommandsHasVariables');
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewPartCommandsHasVariables;